<script>
  import { onMount } from 'svelte'
  import Cookies from 'js-cookie'
  import SignIn from './SignIn.svelte'
  import Main from './Main.svelte'
  import { auth } from './stores/root.js'

  onMount(() => {
    const jwt = Cookies.get('jwt')
    const userData = Cookies.get('user')
    if (jwt && userData) {
      const user = JSON.parse(userData)
      auth.set({
        jwt,
        user,
      })
    }
  })

  console.log('Current Environment: ' + process.env.NODE_ENV)
  console.log('Current API: ' + process.env.API_URL)
</script>

{#if $auth.jwt}
  <Main />
{:else}
  <SignIn />
{/if}

<style lang="scss" global>
  @import './main.scss';
</style>
